import { columnsAutorizations } from "pages/autorization-payments";
import { IElectronicDocuments } from "shared/models";

export const convertPaymentAuthorization = (data: any): IElectronicDocuments => {

    const content = () => {
        if (data?.content[0]?.electronicDocument) {
            return data?.content?.map((item: any): columnsAutorizations => {
                return {
                    invoiceNumber: item?.electronicDocument?.documentNumber,
                    nit: item?.electronicDocument?.provider.employerIdNumber,
                    provider: item?.electronicDocument?.provider.name,
                    totalValue: item?.electronicDocument?.totalValue,
                    invoiceState: item?.electronicDocument?.state.name,
                    valueEndorsed: item?.electronicDocument?.paymentAuthorizationTotalValue,
                    valueAcceptedGloss: item?.electronicDocument?.acceptedConsolidatedValue,
                    valueinNoAgreement: item?.electronicDocument?.consolidatedInNoAgreementValue,
                    authorizedBy: item?.electronicDocument?.currentUser.name,
                    paymentLine: item?.electronicDocument?.paymentLine.name,
                    contract: item?.electronicDocument?.contractNumber,
                    paymentReference: 'hu-futura',
                    filingNumber: item?.electronicDocument?.filingNumber,
                    initialServiceDate: item?.electronicDocument?.attentionPeriodStartedAt,
                    endDateofService: item?.electronicDocument?.attentionPeriodEndedAt,
                    creditNoteNumber: item?.creditNoteNumber,
                    totalCreditNote: item?.sumCreditNote,
                    withCertificate: item?.electronicDocument?.isCertified ? 'SI' : 'NO',
                    id: item?.electronicDocument?.id
                }
                
            })
        } else if (data?.content[0]?.data) {
            return data?.content?.map(({data}: any): any => {
                return {
                    name: data.nombreCompleto,
                    email: data.email,
                    existUser: data.migrate,
                    id: data.objectId,
                }
            })
        } else {
            return data?.content
        }
    } 

    return {
        content: content(),
        totalElements: data.totalElements,
        number: data.number,
        size: data.size,
        contentSize: data.contentSize,
    }

}